import React from 'react';
import Layout from '../../components/Layout';
import BecomeACompany from './BecomeACompany';

const title = 'Become a Company — BestHand';
const description =
  'Onboard your construction or home-improvement company onto BestHand Large Projects: verify your business, upload licenses and insurance, connect payouts, and start quoting on big jobs.';

async function action({ largeProjectsEnabled }) {
  // LARGE PROJECTS FLAG: when OFF this LP route is unreachable -> redirect home
  // (additive guard; small-jobs routes untouched). Flag read from the router
  // context (server-only DB read in server.js / SSR-seeded runtime on client);
  // fail-closed at the source.
  if (!largeProjectsEnabled) {
    return { redirect: '/' };
  }
  return {
    title,
    description,
    component: (
      <Layout companyMode>
        <BecomeACompany />
      </Layout>
    ),
  };
}

export default action;
